import { apiFetch } from './client';

export const campaignsApi = {
  list: (status) => apiFetch('/api/campaigns', { params: { status } }),
  get: (id) => apiFetch(`/api/campaigns/${id}`),
  create: (data) => apiFetch('/api/campaigns', { method: 'POST', body: data }),
  update: (id, patch) => apiFetch(`/api/campaigns/${id}`, { method: 'PATCH', body: patch }),
  remove: (id) => apiFetch(`/api/campaigns/${id}`, { method: 'DELETE' }),
};
